// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ExamineVerifyFilledSvg from "@fishx/icons-svg/es/asn/ExamineVerifyFilled";
import FishxIcon from '../components/FishxIcon';

var ExamineVerifyFilled = function ExamineVerifyFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: ExamineVerifyFilledSvg
  }));
};

ExamineVerifyFilled.displayName = 'ExamineVerifyFilled';
export default React.forwardRef(ExamineVerifyFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/ExamineVerifyFilled.js
// module id = 2626
// module chunks = 0